import { Field, ErrorMessage } from 'formik' 
import { AiOutlineExclamationCircle } from "react-icons/ai";

const PassConfirmInput = ({ errors, touched }) => {
  return (
    <>
        <label htmlFor='passwordConfirm'>Confirm password</label>
        <Field 
            name="passwordConfirm"
            type="password"
            placeholder="••••••••••••"
            className={errors.passwordConfirm && touched.passwordConfirm ? "input-error" : ""}
        />
        <ErrorMessage name="passwordConfirm">
            {msg => (
                <p className="error-msg">
                    <AiOutlineExclamationCircle />
                    <span>{msg}</span>
                </p>
            )}
        </ErrorMessage>
</>
  )
}

export default PassConfirmInput